import React from "react";

import { Event, EventQuery, mapInterpretationToString } from "lib/build/events";

export function findEvent<T = unknown>(
	extra: Event<unknown>[],
	query: EventQuery
): Event<T> | null {
	if (query.interpretation !== undefined) {
		const sid = mapInterpretationToString(query.interpretation);
		for (const el of extra) {
			if (el.sid === sid) {
				return el as Event<T>;
			}
		}
	}
	return null;
}

export function renderNumberEvent(
	event: Event<number | undefined> | null
): React.ReactNode {
	if (event === null || event.value === undefined) {
		return "-";
	}
	if (event.schema === undefined || event.schema.unit === undefined) {
		return <>{event.value}</>;
	}
	return (
		<>
			<b>{event.value}</b> <i>{event.schema.unit}</i>
		</>
	);
}

export function mapNumberEventToString(
	event: Event<number | undefined> | null
): string {
	if (event === null || event.value === undefined) {
		return "";
	}
	if (event.schema === undefined || event.schema.unit === undefined) {
		return `${event.value}`;
	}
	return `${event.value} ${event.schema.unit}`;
}

export function compareNumberEvents(
	a: Event<number | undefined> | null,
	b: Event<number | undefined> | null
): number {
	if (a === null && b === null) {
		return 0;
	}
	if (a === null) {
		return 1;
	}
	if (b === null) {
		return -1;
	}
	if (a.value === undefined && b.value === undefined) {
		return 0;
	}
	if (a.value === undefined) {
		return 1;
	}
	if (b.value === undefined) {
		return -1;
	}
	if (a.value < b.value) {
		return -1;
	}
	if (a.value > b.value) {
		return 1;
	}
	return 0;
}

export function compareDates(
	a: Date | string | number | undefined,
	b: Date | string | number | undefined
): number {
	if (a === undefined && b === undefined) {
		return 0;
	}
	if (a === undefined) {
		return -1;
	}
	if (b === undefined) {
		return 1;
	}
	const aT = (a instanceof Date ? a : new Date(a)).getTime();
	const bT = (b instanceof Date ? b : new Date(b)).getTime();
	if (aT < bT) {
		return -1;
	}
	if (aT > bT) {
		return 1;
	}
	return 0;
}
